import { defaultLanguages, type ZudokuConfig } from "zudoku";
import { apis } from "./config/apisConfig";
import { docs } from "./config/docConfig";
import { navigation } from "./config/navigationConfig";
import { plugins } from "./config/pluginConfig";
import { protectedRoutes } from "./config/protectedRoutesConfig";
import { theme } from "./config/theme";
import { AUTH_SCOPES } from "./config/authScopes";
import { AuthOverride } from "./src/Components/AuthOverride";
import { CatalogMainHeading } from "./src/Components/CatalogMainHeading";
import { CatalogVisibilityGate } from "./src/Components/CatalogVisibilityGate";
import { EamLoginTooltip } from "./src/Components/EamLoginTooltip";
// import { LogoutButton } from "./src/Components/LogoutButton";

const auth0Domain = process.env.ZUDOKU_PUBLIC_AUTH0_DOMAIN || "login.vpctest.com";

const baseConfig: ZudokuConfig = {
  port: 9000,
  defaults: {
    apis: {
      expandAllTags: false,
      schemaDownload: {enabled: true}
    },
  },
  aiAssistants: ["claude","chatgpt"],
  metadata: {
    title: "%s | OpenGov Developer Portal",
    defaultTitle: "OpenGov Developer Portal",
    description: "The OpenGov Developer Portal provides APIs, documentation, and tools to integrate with the OpenGov Public Service Platform.",
    favicon: "/wand_favIcon.png",
  },
  site: {
    showPoweredBy: false,
    logo: {
      src: {
        light: "opengov_logo_light.svg",
        dark: "opengov_logo_dark.svg",
      },
      alt: "OpenGov Logo",
    },
    footer: {
      position: "center",
      columns: [
        {
          title: "Resources",
          position: "start",
          links: [
            { label: "Documentation", href: "/docs/overview" },
            { label: "API Catalog", href: "/catalog" },
          ]
        },
        {
          title: "Legal",
          position: "center",
          links: [
            { label: "OpenGov Developer Terms", href: "/terms-of-use" },
          ]
        },
        {
          title: "Company",
          position: "end",
          links: [
            { label: "OpenGov Home", href: "http://opengov.com" },
          ]
        },
      ],
      copyright: `© ${new Date().getFullYear()} OpenGov`,
      social: [
        {
          label: "LinkedIn",
          href: "https://www.linkedin.com/company/opengov-inc",
        },
        {
          // label: "Facebook",
          icon: "facebook",
          href: "https://www.facebook.com/opengovinc",
        },
      ]
    },
  },
  theme,
  navigation,
  navigationRules: [
    {
      type: "insert",
      match: "API Catalog/Business Objects",
      position: "after",
      items: [
        {
          type: "doc",
          file: "docs/eam/data-types",
          label: "Data Types",
        },
      ],
    },
    {
      type: "insert",
      match: "API Catalog/Layout",
      position: "after",
      items: [
        {
          type: "doc",
          file: "docs/eam/error-handling",
          label: "Exception Handling",
        },
      ],
    },
  ],
  catalogs: {
    path: "catalog",
    label: "API Catalog",
    items: ["plc-api", "plc-app-store", "bnp-api", "vm-api"],
  },
  apis,
  slots: {
    "head-navigation-start": (
      <>
        <AuthOverride />
        <CatalogVisibilityGate />
      </>
    ),
    "content-before": CatalogMainHeading,
    "head-navigation-end": <EamLoginTooltip />,
  },
  ...(process.env.ZUDOKU_PUBLIC_AUTH0_CLIENT_ID && process.env.ZUDOKU_PUBLIC_AUTH0_AUDIENCE
    ? {
      authentication: {
        type: "auth0",
        audience: process.env.ZUDOKU_PUBLIC_AUTH0_AUDIENCE,
        clientId: process.env.ZUDOKU_PUBLIC_AUTH0_CLIENT_ID,
        domain: auth0Domain,
        scopes: AUTH_SCOPES,
      },
      protectedRoutes,
    }
    : {}),
  docs,
  syntaxHighlighting: {
    languages: [...defaultLanguages, "csv"]
  },
  plugins
};

// Exclude certain config options in production
const config: ZudokuConfig = {
  ...baseConfig,
  // apiKeys: {
  //   enabled: true,
  //   ...apiKeyService,
  // }
};

export default config;
